var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 7.83333V0.5M15.1663 15.1667V12.4167M2.33301 15.1667V11.5M15.1663 8.75V0.5M8.74967 3.25V0.5M8.74967 15.1667V6.91667",
    stroke: "#615E83",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 11.5002C3.34586 11.5002 4.16667 10.6794 4.16667 9.66683C4.16667 8.65431 3.34586 7.8335 2.33333 7.8335C1.32081 7.8335 0.5 8.65431 0.5 9.66683C0.5 10.6794 1.32081 11.5002 2.33333 11.5002Z",
    stroke: "#615E83",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75033 6.91667C9.76285 6.91667 10.5837 6.09586 10.5837 5.08333C10.5837 4.07081 9.76285 3.25 8.75033 3.25C7.7378 3.25 6.91699 4.07081 6.91699 5.08333C6.91699 6.09586 7.7378 6.91667 8.75033 6.91667Z",
    stroke: "#615E83",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1663 12.4167C16.1789 12.4167 16.9997 11.5959 16.9997 10.5833C16.9997 9.57081 16.1789 8.75 15.1663 8.75C14.1538 8.75 13.333 9.57081 13.333 10.5833C13.333 11.5959 14.1538 12.4167 15.1663 12.4167Z",
    stroke: "#615E83",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e710fe721ae6371caea93d3473764f6c.svg";
export { ForwardRef as ReactComponent };